import { FontIcon, Link, MessageBar, MessageBarType, mergeStyles } from '@fluentui/react';
import Strings from '../../localization/strings';
import './AdminConsentWarning.scss';

/** Shown after a Microsoft sign-up the user could not complete - most often a missing tenant consent for the User.Read profile scope it asks for. */
const AdminConsentWarning: React.FC<{ className?: string }> = ({ className }) => {
    const myStrings = Strings.introPage.adminConsentWarning;

    return (
        <MessageBar messageBarType={MessageBarType.warning} className={mergeStyles('admin-consent-warning', className)}>
            {/* Spans, not divs - Fluent v8 puts the children inside the bar's own .ms-MessageBar-innerText span. */}
            <span className="admin-consent-warning__text">
                <span className="admin-consent-warning__line">{myStrings.accessNotGranted}</span>
                <span className="admin-consent-warning__line">{myStrings.scopePurpose}</span>
                <span className="admin-consent-warning__line">{myStrings.contactAdminOrUseEmail}</span>
                <Link className="admin-consent-warning__link" href={myStrings.learnMoreLink} target="_blank" rel="noreferrer noopener">
                    {myStrings.learnMore}
                    <FontIcon iconName="OpenInNewWindow" />
                </Link>
            </span>
        </MessageBar>
    );
};

export default AdminConsentWarning;
